import React, { Component } from 'react';
import DialogInput from '../advanced/DialogInput';
import Button from './Button';
import DialogHeaderWithClose from './DialogHeaderWithClose';

class ConfirmPODialog extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { closeDialog, confirmDialog, branchName, totalPriceMatch, model, createPO } = this.props || {};
        const { Products } = model || {};

        return (
            <DialogInput
                title={<DialogHeaderWithClose text="Confirm Purchase Order Add" classicClass="posDialogClassic" handleClose={() => closeDialog()} />}
                actions={[
                    <Button
                        key={1}
                        type="CancelButton"
                        name="buttonCancel"
                        className="btn-space"
                        label="Cancel"
                        onTouchTap={() => closeDialog()} />,
                    <Button
                        key={2}
                        name="ConfirmButton"
                        label="Proceed"
                        primary={true}
                        onTouchTap={() => createPO()} />]}
                modal={true}
                handleClose={() => closeDialog()}
                open={confirmDialog}>
                    <div>{branchName ? <p>The branch this Purchase Order is being added to is: <b>{branchName}</b></p> : ''}
                    {totalPriceMatch ? <div><p>This Purchase Order has a similar total price to: <b className="danger">{ this.props.POName }</b></p>
                    <p><i>Do not import the same Purchase Order twice, this will cause inventory problems. If your last attempt to import this PO did not fully receive all products, please manually receive the outstanding products.</i></p></div> : ''}
                    <br/>
                    {model && <p>The products in this Purchase Order are:</p>}
                    <ul style={{maxHeight:`300px`, overflowY:`auto`, listStyleType:`circle`}}>
                        {Products && Products.map(item => <React.Fragment key={item.SKU}>{item.ProductName ? <li>{item.ProductName}</li> : <li>{item.SKU}</li>}</React.Fragment>)}
                    </ul>
                    {model && Products && <p><b><br/>There are {Products.length} products in this Purchase Order.</b></p>}
                    <br/>
                    <p>Do you want to proceed adding this Purchase Order?</p></div>
            </DialogInput>
        );
    }
}


export default (ConfirmPODialog);